/**
 * `/mail/calendar` — Calendar pane of the mail suite.
 *
 * Sibling pane to `/mail` (inbox), both share the layout in
 * `routes/mail.tsx`. Calendar is "part of mail" per founder
 * direction — the Outlook/Proton pattern of one productivity suite
 * with internal panes.
 *
 * Cross-feature: reads any pending EventPrefill the inbox pane
 * wrote to sessionStorage before navigating here. When present,
 * Calendar auto-opens its CreateEventForm with the draft
 * prefilled.
 *
 * Joint-project: <Calendar> itself is in @postopia/calendar-ui
 * and is consumed by MyVigator's bundle too. Neither
 * @postopia/mail-ui nor @postopia/calendar-ui imports the other —
 * the bridge is the host's sessionStorage shim.
 */

import { createFileRoute } from '@tanstack/react-router';
import { useMemo } from 'react';
import { Calendar } from '@postopia/calendar-ui';
import { takePendingEventDraft } from '../lib/cross-feature';

export const Route = createFileRoute('/mail/calendar')({
  component: CalendarPane,
});

function CalendarPane() {
  // Drain any cross-feature draft on mount. `useMemo` (not state) so
  // the draft is taken synchronously on the first render — Calendar's
  // own `useEffect` then opens the form. Refresh doesn't re-open
  // because sessionStorage is already cleared.
  const prefill = useMemo(() => takePendingEventDraft(), []);

  return <Calendar {...(prefill ? { prefill } : {})} />;
}
